import React from 'react';

import { OpenItemsProps } from './OpenItems.props';

import OpenItemsView from './OpenItems.view';

const OpenItemsContainer = (props: OpenItemsProps) => {
  return <OpenItemsView />;
};

export default OpenItemsContainer;
